import { useState } from "react";
import { ListGroup } from "react-bootstrap";

import { WALKTHROUGH } from "../walkthrough";
import { UserGuideModal } from "./UserGuideModal";
import { USER_GUIDE_MENU } from "utils/constants";
import { iconPlay } from "assets/icons";
import { UserGuideContainer } from "../HelpCenter.styles";
import { Button } from "components/Button";
import { SubHeading } from "style/components/SubHeading.styles";

export const UserGuide = () => {
  const [modalTitle, setModalTitle] = useState("");
  const [showMediaModal, setMediaModal] = useState(false);
  const [currentWalkthrough, setCurrentWalkthrough] = useState({});

  const toggleMediaModal = () => {
    setMediaModal(!showMediaModal);
  };

  const handleStartClick = (menu) => {
    const walkthrough = WALKTHROUGH[menu.key];
    setModalTitle(menu.name);
    toggleMediaModal();
    setCurrentWalkthrough({});

    if (walkthrough) {
      setCurrentWalkthrough(walkthrough);
    }
  };

  return (
    <UserGuideContainer>
      <div className="wrapper">
        <SubHeading>User Guide</SubHeading>

        <ListGroup>
          {USER_GUIDE_MENU.map((menu) => (
            <ListGroup.Item key={menu.key}>
              {menu.name}{" "}
              <Button
                size="small"
                className="btn-start"
                onClick={() => handleStartClick(menu)}
              >
                <img src={iconPlay} className="icon-play" />
                Start
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>

      <UserGuideModal
        show={showMediaModal}
        onHide={toggleMediaModal}
        url="https://youtu.be/tIJ0XM7emDE"
        title={modalTitle}
        walkthroughSteps={currentWalkthrough}
      />
    </UserGuideContainer>
  );
};
